<template>

      <div class="wrapper wrapper-content">
        <div class="container-fluid">
 
<div class="">
  <div class="row">
    <div class="col-xs-12">
      <div class="ibox m-b-none ">
      <div class="ibox-title">
        <h5>
          <router-link :to="{name: 'reqcredit'}" class="text-primary-new">แจ้ง ฝาก/ถอน</router-link> / แจ้งถอนเครดิต
        </h5>
      </div>
      <div class="ibox-content">

        <form id="dwithdraw_form" @submit.prevent.once="processWithdraw" class="m-t form-horizontal fv-form fv-form-bootstrap">
                      
          <div class="form-group">
            <label class="col-xs-12 col-lg-1 control-label" style="text-align:left"></label>
            <div class="col-xs-12 col-sm-6">
              <h4 class="alert alert-warning">คุณสามารถใช้สิทธิการถอนได้ {{ today_limit }} ครั้งต่อวัน, ขณะนี้คุณใช้สิทธิถอนไปแล้ว {{ today_record }} ครั้ง</h4>
            </div>
          </div>
          
          <!-- <div class="form-group">
            <label class="col-xs-12 col-lg-1 control-label" style="text-align:left">ธนาคาร</label>
            <div class="col-lg-11 text-danger">
              <img src="/assets/imgs/banks/kbank.svg" style="background:#138f2d;width:20px"> <strong>ธนาคารกสิกรไทย</strong><div style="margin-left:23px;"><strong>ชื่อบัญชี:</strong> xx xxxxxx <br> <strong>เลขที่บัญชี:</strong> 00XXXYYZZZ</div>
            </div>
          </div> -->

          <div class="form-group has-feedback">
            <label class="col-xs-12 col-lg-1 control-label" style="text-align:left">จำนวนเงิน</label>
            <div class="col-xs-12 col-sm-6">
              <div class="input-group">
                <span class="input-group-addon">฿</span>
                <input type="text" name="amount" class="form-control" :placeholder="'ระบุจำนวนเงิน (ขั้นต่ำ ' + amount_limit + ' บาท)'" id="amount" v-model="amount">
              </div><i class="form-control-feedback fv-bootstrap-icon-input-group" data-fv-icon-for="amount" style="display: none;"></i>
            <small class="help-block" data-fv-validator="notEmpty" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">โปรดระบุข้อมูลในส่วนนี้</small><small class="help-block" data-fv-validator="integer" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">กรุณาระบุยอดเป็นจำนวนเต็มเท่านั้น ห้ามระบุทศนิยม</small><small class="help-block" data-fv-validator="greaterThan" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">กรุณาระบุค่ามากกว่าหรือเท่ากับ %s</small></div>
          </div>

          <div class="form-group">
            <label class="col-xs-12 col-lg-1 control-label" style="text-align:left"></label>
            <div class="col-xs-12 col-sm-6">
              <small>กรุณาตรวจสอบข้อมูลของท่านให้ถูกต้อง และกดปุ่ม <span class="text-success">แจ้งถอนเครดิต</span></small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-xs-12 col-lg-1 control-label" style="text-align:left"></label>
            <div class="col-xs-12 col-sm-6">
              <button class="btn btn-xs-block btn-danger" type="submit"><i class="fa fw fa-minus-circle"></i> แจ้งถอนเครดิต</button>
              <router-link :to="{name: 'reqcredit'}" class="btn btn-xs-block btn-primary"> ยกเลิก</router-link>
            </div>
          </div>
        </form>
        </div>

      </div> <!-- /ibox m-b-none -->
    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->
</div>

        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'withdraw',
    data () {
        return {
            amount: '',
            description: '',
            today_record: 0,
            total_amount: 0,
            today_limit: 2,
            amount_limit: 1,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        })
    },
    mounted () {
    },
    methods: {
        async processWithdraw () {
            //console.log('processWithdraw amount', this.amount)

            if ( parseFloat(this.amount) >= this.amount_limit && this.validateMoney(this.amount) ) {

                let transaction_date = moment().format('YYYY-MM-DD HH:mm')
                let withdrawData = {
                    customer_id: this.user.id,
                    amount: this.amount,
                    action: 'credit', 
                    description: this.description,
                    status_id: 1,
                    transaction_date: transaction_date,
                    bank_id: 1,
                }

                try {

                    const response = await this.$store.dispatch('ledger/getUserBalance', this.user.account_id)
                    let current_balance = parseFloat(response.balance)
                    //console.log('processWithdraw response', response, current_balance)

                    // limit
                    if ( current_balance >= this.amount_limit ) {

                        // deduct balance
                        //current_balance = current_balance - parseFloat(this.total_amount)

                        let remain_balance =  current_balance - parseFloat(this.amount)

                        if ( remain_balance >= 0 ) {
                            //console.log('processWithdraw remain_balance can withdraw', remain_balance)

                            const responseCreate = await this.$store.dispatch('jobtask/createJobtask', withdrawData)
                            //console.log('createJobtask responseCreate', responseCreate)

                            if ( responseCreate && responseCreate.data.message == 'SUCCESS' ) {
                                this.$toasted.success('ได้รับการแจ้งถอนแล้ว.')
                            }
                            else {
                                this.$toasted.error('ไม่สามารถทำรายการได้ เนื่องจากยังมีรายการแจ้งถอนก่อนหน้า ค้างอยู่ในระบบ')
                            }
                            this.$router.push({name: 'reqcredit',})

                        }
                        else {
                            this.$toasted.info('จำนวนเครดิตของท่านคือ: ' + current_balance)
                            //console.log('processWithdraw remain_balance cannot withdraw', remain_balance)
                            this.$toasted.error('จำนวนเงินที่แจ้งถอน มีจำนวนเกินเครดิตท่านเหลือ')
                        }

                    }
                    else {
                        this.$toasted.error('เครดิตท่านเหลือไม่พอต่อการแจ้งถอน')
                    }

                } catch (error) {
                    let error_msg = 'There was an error connecting to the server.'
                    let response = error.response.data
                    if ( response ) {
                        error_msg = 'ไม่สามารถแจ้งถอนเครดิต ' + response.message
                    }
                    this.$toasted.error(error_msg)
                    this.$router.push({name: 'reqcredit',})
                } finally {
                    this.$root.$emit('navbar')
                }

            }
            else {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง จำนวนเงินต้องมากกว่า 0 (ขั้นต่ำ ' + this.amount_limit +  ') และเป็น ตัวเลข และ/หรือ จุดทศนิยมสองตำแหน่ง เท่านั้น.')
            }
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        validateMoney (amount) {
            let rgx = /^[0-9]+(\.[0-9]{1,2})?$/g
            return amount.match(rgx)
        },

        async loadWithdrawData () {
            try {

                const responseWithdraw = await this.$store.dispatch('jobtask/getTotalWithdraw',this.user.id)
                //console.log('processWithdraw responseWithdraw', responseWithdraw)

                //this.total_amount   = responseWithdraw.total_amount
                this.today_record = responseWithdraw.today_record
                this.today_limit = responseWithdraw.today_withdraw_limit
                this.amount_limit = responseWithdraw.DEFAULT_LIMIT

                if ( this.today_record >= this.today_limit ) {
                    this.$toasted.error('คุณใช้สิทธิการถอนไปแล้ว '+ this.today_record +' ครั้งต่อวัน, ไม่สามารถแจ้งถอนได้อีกในวันนี้')
                    this.$router.push({name: 'reqcredit',})
                }

            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                let response = error.response.data
                if ( response ) {
                    error_msg = 'ยังไม่เปิดให้แจ้งถอนเครดิต, ทางระบบยังไม่พร้อมให้บริการ ' + response.message
                }
                this.$toasted.error(error_msg)
                this.$router.push({name: 'reqcredit',})
            }
        }

    },
    created () {
        this.loadWithdrawData()
    },
}
</script>

<style lang="sass" scoped>
</style>
